import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

var initializeBlock = function( $block ) {

  if(!!$block[0]){
    $block = $block[0];
  }
  
  const teamSlider = document.querySelector('.team-slider');

  if( teamSlider ) {
    var splide = new Splide( '.team-slider' , {
      type: 'slide',
      speed: 800,
      perPage: 4,
      perMove: 1,
      arrows: true,
      pagination: false,
      gap: 16,
      // rewind: true,
      waitForTransition: false,

      breakpoints: {
        960: {
          perPage: 3,
        },
        640: {
          perPage: 2,
        },
        420: {
          perPage: 1,
        },
      }

    });
    splide.mount();
  }

}

export const initializeTeamSlider = function() {
  // Initialize each block on page load (front end).
  var sliders = document.querySelectorAll('.team-slider');
  Array.prototype.forEach.call(sliders, function(el){
    initializeBlock(el);
  });
}

export const initializeTeamSliderEditor = function() {
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=team-slider', initializeBlock );
  }
}